import get from 'lodash/get'
import isNumber from 'lodash/isNumber'
import {createSelector} from 'reselect'
import verge from 'verge'

import {
  DESKTOP,
  PHONE,
  MEDIUM_DESKTOP,
  MEDIUM_TABLET,
  SMALL_DESKTOP,
  SMALL_PHONE,
  TABLET,
} from '../const'

// -- Helpers

const viewportWidthIs = (val, func) => func(isNumber(val) ? val : verge.viewportW())
const isMediumDesktopOrLarger = (val) => viewportWidthIs(val, (x) => x >= MEDIUM_DESKTOP.START)
const isDesktop = (val) => viewportWidthIs(val, (x) => x >= DESKTOP.START)
const isMediumTabletOrLarger = (val) => viewportWidthIs(val, (x) => x >= MEDIUM_TABLET.START)
const isSmallDesktop = (val) =>
  viewportWidthIs(val, (x) => x >= SMALL_DESKTOP.START && x <= SMALL_DESKTOP.END)
const isTablet = (val) => viewportWidthIs(val, (x) => x >= TABLET.START && x <= TABLET.END)
const isPhone = (val) => viewportWidthIs(val, (x) => x <= PHONE.END)
const isSmallPhone = (val) => viewportWidthIs(val, (x) => x <= SMALL_PHONE.END)

// -- Standard

export const scrollX = (state) => get(state, 'pane.scrollX')
export const scrollY = (state) => get(state, 'pane.scrollY')
export const viewportHeight = (state) => get(state, 'pane.viewportHeight')
export const viewportWidth = (state) => get(state, 'pane.viewportWidth')
export const pane = (state) => get(state, 'pane')

// -- Computed

export const windowIsMediumDesktopOrLarger = createSelector(viewportWidth, isMediumDesktopOrLarger)

export const windowIsSmallDesktop = createSelector(viewportWidth, isSmallDesktop)

export const windowIsDesktop = createSelector(viewportWidth, isDesktop)

export const windowIsMediumTabletOrLarger = createSelector(viewportWidth, isMediumTabletOrLarger)

export const windowIsTablet = createSelector(viewportWidth, isTablet)

export const windowIsPhone = createSelector(viewportWidth, isPhone)

export const windowIsSmallPhone = createSelector(viewportWidth, isSmallPhone)

export const windowScrolledDown = createSelector(scrollY, (scrollYPos) => scrollYPos > 0)

// -- Other

export const wrap = (subState) => ({pane: subState})
